"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group 313"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0 3.00039C0 2.66902 0.268629 2.40039 0.6 2.40039H11.4C11.7314 2.40039 12 2.66902 12 3.00039C12 3.33176 11.7314 3.60039 11.4 3.60039H0.6C0.268629 3.60039 0 3.33176 0 3.00039Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.79922 1.2C4.64009 1.2 4.48748 1.26321 4.37496 1.37574C4.26243 1.48826 4.19922 1.64087 4.19922 1.8V3C4.19922 3.33137 3.93059 3.6 3.59922 3.6C3.26785 3.6 2.99922 3.33137 2.99922 3V1.8C2.99922 1.32261 3.18886 0.864773 3.52643 0.527208C3.86399 0.189642 4.32183 0 4.79922 0H7.19922C7.67661 0 8.13445 0.189642 8.47201 0.527208C8.80958 0.864773 8.99922 1.32261 8.99922 1.8V3C8.99922 3.33137 8.73059 3.6 8.39922 3.6C8.06785 3.6 7.79922 3.33137 7.79922 3V1.8C7.79922 1.64087 7.73601 1.48826 7.62348 1.37574C7.51096 1.26321 7.35835 1.2 7.19922 1.2H4.79922ZM1.79922 2.4C2.13059 2.4 2.39922 2.66863 2.39922 3V11.4C2.39922 11.5591 2.46243 11.7117 2.57495 11.8243C2.68748 11.9368 2.84009 12 2.99922 12H8.99922C9.15835 12 9.31096 11.9368 9.42348 11.8243C9.53601 11.7117 9.59922 11.5591 9.59922 11.4V3C9.59922 2.66863 9.86785 2.4 10.1992 2.4C10.5306 2.4 10.7992 2.66863 10.7992 3V11.4C10.7992 11.8774 10.6096 12.3352 10.272 12.6728C9.93445 13.0104 9.47661 13.2 8.99922 13.2H2.99922C2.52183 13.2 2.06399 13.0104 1.72643 12.6728C1.38886 12.3352 1.19922 11.8774 1.19922 11.4V3C1.19922 2.66863 1.46785 2.4 1.79922 2.4Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_3",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.79824 5.40039C5.12961 5.40039 5.39824 5.66902 5.39824 6.00039V9.60039C5.39824 9.93176 5.12961 10.2004 4.79824 10.2004C4.46687 10.2004 4.19824 9.93176 4.19824 9.60039V6.00039C4.19824 5.66902 4.46687 5.40039 4.79824 5.40039Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_4",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.19961 5.40039C7.53098 5.40039 7.79961 5.66902 7.79961 6.00039V9.60039C7.79961 9.93176 7.53098 10.2004 7.19961 10.2004C6.86824 10.2004 6.59961 9.93176 6.59961 9.60039V6.00039C6.59961 5.66902 6.86824 5.40039 7.19961 5.40039Z",
    fill: fill
  })));
};

exports["default"] = _default;